import { render, staticRenderFns } from "./WinningPayouts.vue?vue&type=template&id=2b3440a5&scoped=true&"
import script from "./WinningPayouts.vue?vue&type=script&lang=js&"
export * from "./WinningPayouts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3440a5",
  null
  
)

export default component.exports